import { db } from '@/shared/services/firebase'

const updateUser = (id, data) => new Promise((resolve, reject) => {
  db.collection('users').doc(id).update(data).then(() => resolve())
    .catch(error => reject(error))
})

// eslint-disable-next-line import/prefer-default-export
export { updateUser }
